
import { Component, OnInit } from "@angular/core";
import { MaterialModule } from "../../material.module";
import { LeftMenuComponent } from "../../menu/left-menu/left-menu.component";
import { CmdbSyncComponent } from "../cmdb-sync/cmdb-sync.component";

@Component({
  selector: "cmdb-management",
  templateUrl: "./cmdb-management.component.html",
  styleUrls: ['./cmdb-management.component.scss'],
  imports: [MaterialModule, LeftMenuComponent, CmdbSyncComponent]
})
export class CmdbManagementComponent implements OnInit {

  constructor() {}

  ngOnInit(): void {}
}
